// src/app/helpers/date-utils.ts
export class DateUtils {
  
  static formatDateForDisplay(date: string): string {
    const [year, month, day] = date.split('-');
    return `${month}/${day}/${year}`; // Format as MM/DD/YYYY for frontend display
  }
  
  static formatDateForBackend(date: string): string {
    const [month, day, year] = date.split('/');
    return `${year}-${month}-${day}`; // Convert back to YYYY-MM-DD for form control
  }

  static getCurrentFormattedDate(): string {
    const today = new Date();
    const year = today.getFullYear();
    const month = (today.getMonth() + 1).toString().padStart(2, '0');
    const day = today.getDate().toString().padStart(2, '0');
    return `${month}/${day}/${year}`;
  } 

  /**
   * Generate a list of school years based on the current date
   * @param totalYears Number of school years to generate
   * @param includeFuture Whether to include years after the current year
   */
  static getSchoolYears(totalYears: number = 6, includeFuture: boolean = false): string[] {
    const currentYear = new Date().getFullYear();
    const currentMonth = new Date().getMonth() + 1;

    // Determine starting school year
    let startYear = currentMonth >= 8 ? currentYear : currentYear - 1;

    // If including future years, start with current school year and go forward
    if (includeFuture) {
      return Array.from({ length: totalYears }, (_, i) => {
        const year = startYear + i;
        return `${year}-${year + 1}`;
      });
    }

    // Default: go backward in time
    return Array.from({ length: totalYears }, (_, i) => {
      const year = startYear - i;
      return `${year}-${year + 1}`;
    });
  }

  /**
   * Get the current school year based on today's date
   */
  static getCurrentSchoolYear(): string {
    const currentYear = new Date().getFullYear();
    const currentMonth = new Date().getMonth() + 1;
    const startYear = currentMonth >= 8 ? currentYear : currentYear - 1;
    return `${startYear}-${startYear + 1}`;
  }


}
  